import React from "react";
import ReactECharts from "echarts-for-react";

const GridInteractionLineChart: React.FC = () => {
  const timings = [
    "23:00",
    "00:00",
    "01:00",
    "02:00",
    "03:00",
    "04:00",
    "05:00",
    "06:00",
    "07:00",
    "08:00",
    "09:00",
    "10:00",
  ];

  // Randomized data for Energy Fed and Energy Drawn
  const energyFedData = [90, 80, 60, 70, 90, 30, 60, 90, 60, 50, 70, 80];
  const energyDrawnData = [80, 90, 70, 50, 60, 90, 70, 40, 80, 70, 60, 90];

  const options = {
    xAxis: {
      type: "category",
      data: timings,
      axisLabel: {
        color: "#181B25",
        fontSize: 11,
        fontWeight: 400,
      },
    },
    yAxis: {
      type: "value",
      name: "kWh",
      nameLocation: "end",
      axisLabel: {
        formatter: "{value}",
        color: "#5F6368",
        fontSize: 9,
        fontWeight: 400,
        lineHeight: 11,
        letterSpacing: 0.2,
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: "#e0e0e0",
          type: "dashed",
        },
      },
      max: 120,
      interval: 30,
    },
    tooltip: {
      trigger: "axis",
      backgroundColor: "#181B25",
      borderWidth: 0,
      textStyle: {
        color: "#fff",
        fontSize: 12,
      },
      formatter: (params: any) => {
        const [fed, drawn] = params;
        return `
          <div style="font-size: 12px; color: #fff; padding: 5px;">
            <b>${fed.axisValue}</b>
            <br/>
            <span style="color: ${fed.color}">●</span> ${fed.seriesName}: ${fed.value} kWh
            <br/>
            <span style="color: ${drawn.color}">●</span> ${drawn.seriesName}: ${drawn.value} kWh
          </div>
        `;
      },
    },
    legend: {
      data: ["Energy Fed", "Energy Drawn"],
      textStyle: {
        fontSize: 12,
        color: "#4C5269",
      },
    },
    grid: {
      left: "5%",
      right: "5%",
      bottom: "10%",
      containLabel: true,
    },
    series: [
      {
        name: "Energy Fed",
        data: energyFedData,
        type: "line",
        lineStyle: {
          color: "#9CE976",
          width: 2,
        },
        itemStyle: {
          color: "#9CE976",
        },
        symbol: "circle",
        symbolSize: 6,
      },
      {
        name: "Energy Drawn",
        data: energyDrawnData,
        type: "line",
        lineStyle: {
          color: "#1976d2",
          width: 2,
        },
        itemStyle: {
          color: "#1976d2",
        },
        symbol: "circle",
        symbolSize: 6,
      },
    ],
  };

  return <ReactECharts option={options} style={{ height: "400px" }} />;
};

export default GridInteractionLineChart;
